module.exports = __webpack_public_path__ + "static/media/workloads-entity-map-explorations.fdacd971.jpg";